// 新建对象时，对象图标库
export const icons = [
  // 通用类
  'qfei-icon-navigation-collapse-outlined',
  'qfei-icon-navigation-expanded-outlined',
  'qfei-icon-detail-page-outlined',
  'qfei-icon-user-outlined',
  'qfei-icon-filter-asc-outlined',
  'qfei-icon-filter-desc-outlined',
  'qfei-icon-lock-outlined',
  'qfei-icon-unlock-outlined',
  'qfei-icon-plugin-outlined',
  'qfei-icon-quotation-sheet-outlined',
  'qfei-icon-app-outlined',
  'qfei-icon-search-outlined',
  'qfei-icon-move-outlined',
  'qfei-icon-return-order-outlined',
  'qfei-icon-letter-outlined',
  'qfei-icon-template-outlined',
  'qfei-icon-priority-outlined',
  'qfei-icon-download-outlined',
  'qfei-icon-descending-order-outlined',
  'qfei-icon-website-outlined',
  'qfei-icon-view-prohibited-outlined',
  'qfei-icon-filter-outlined',
  'qfei-icon-product-outlined',
  'qfei-icon-list-outlined',
  'qfei-icon-organization-outlined',
  'qfei-icon-sub-task-outlined',
  'qfei-icon-circle-person-outlined',
  'qfei-icon-service-desk-outlined',
  'qfei-icon-product-two-outlined',
  'qfei-icon-comment-outlined',
  'qfei-icon-reminder-outlined',
  'qfei-icon-sub-task-one-outlined',
  'qfei-icon-pushpin-outlined',
  'qfei-icon-kanban-outlined',
  'qfei-icon-asterisk-outlined',
  'qfei-icon-reply-outlined',
  'qfei-icon-scheduled-working-hours-outlined',
  'qfei-icon-folder-decrease-outlined',
  'qfei-icon-table-one-outlined',
  'qfei-icon-column-outlined',
  'qfei-icon-box-outlined',
  'qfei-icon-send-outlined',
  'qfei-icon-branch-outlined',
  'qfei-icon-review-result-outlined',
  'qfei-icon-refresh-outlined',
  'qfei-icon-customer-service-outlined',
  'qfei-icon-view-outlined',
  'qfei-icon-app-one-outlined',
  'qfei-icon-panel-outlined',
  'qfei-icon-skin-outlined',
  'qfei-icon-agent-outlined',
  'qfei-icon-update-outlined',
  'qfei-icon-column-setting-outlined',
  'qfei-icon-document-outlined',
  'qfei-icon-favorite-outlined',
  'qfei-icon-operation-log-outlined',
  'qfei-icon-dashboard-outlined',
  'qfei-icon-relevance-outlined',
  'qfei-icon-shrink-outlined',
  'qfei-icon-grouping-outlined',
  'qfei-icon-tag-outlined',
  'qfei-icon-table-outlined',
  'qfei-icon-operation-type-outlined',
  'qfei-icon-color-outlined',
  'qfei-icon-rule-outlined',
  'qfei-icon-operation-field-outlined',
  'qfei-icon-lead-outlined',
  'qfei-icon-more-one-outlined',
  'qfei-icon-order-outlined',
  'qfei-icon-more-two-outlined',
  'qfei-icon-folder-one-outlined',
  'qfei-icon-export-outlined',
  'qfei-icon-object-outlined',
  'qfei-icon-review-audit-outlined',
  'qfei-icon-back-outlined',
  'qfei-icon-process-outlined',
  'qfei-icon-code-outlined',
  'qfei-icon-conversion-outlined',
  'qfei-icon-management-outlined',
  'qfei-icon-ascending-order-outlined',
  'qfei-icon-homepage-outlined',
  'qfei-icon-workbench-outlined',
  'qfei-icon-copy-to-chat-box-add-outlined',
  'qfei-icon-associated-object-table-outlined',
  'qfei-icon-horizontal-vertical-screen-outlined',
  'qfei-icon-layout-outlined',
  'qfei-icon-target-outlined',
  'qfei-icon-business-opportunity-outlined',
  'qfei-icon-operation-source-outlined',
  'qfei-icon-folder-outlined',
  'qfei-icon-more-applications-two-outlined',
  'qfei-icon-contract-document-outlined',
  'qfei-icon-save-outlined',
  'qfei-icon-horizontal-vertical-screen-one-outlined',
  'qfei-icon-automation-outlined',
  'qfei-icon-inspiration-outlined',
  'qfei-icon-conversion-two-outlined',
  'qfei-icon-record-add-outlined',
  'qfei-icon-enlarge-outlined',
  'qfei-icon-create-group-outlined',
  'qfei-icon-tool-outlined',
  'qfei-icon-associated-object-outlined',
  'qfei-icon-copy-outlined',
  'qfei-icon-overall-outlined',
  'qfei-icon-subscription-outlined',
  'qfei-icon-archive-outlined',
  'qfei-icon-modify-outlined',
  'qfei-icon-delete-outlined',
  'qfei-icon-lead-pool-outlined',
  'qfei-icon-merge-outlined',
  'qfei-icon-general-application-outlined',
  'qfei-icon-heart-outlined',
  'qfei-icon-approval-outlined',
  'qfei-icon-add-person-outlined',
  'qfei-icon-more-applications-outlined',
  'qfei-icon-button-outlined',
  'qfei-icon-edit-outlined',
  'qfei-icon-account-switch-outlined',
  'qfei-icon-phone-outlined',
  'qfei-icon-search-two-outlined',
  'qfei-icon-sort-outlined',
  'qfei-icon-share-outlined',
  'qfei-icon-after-sales-outlined',
  'qfei-icon-tool-fragment-outlined',
  'qfei-icon-import-outlined',
  'qfei-icon-folder-add-outlined',
  'qfei-icon-layer-outlined',
  // 字段类
  'qfei-icon-field-outlined',
  'qfei-icon-find-association-outlined',
  'qfei-icon-cascading-selection-outlined',
  'qfei-icon-rich-text-outlined',
  'qfei-icon-hyperlink-outlined',
  'qfei-icon-department-outlined',
  'qfei-icon-date-outlined',
  'qfei-icon-component-outlined',
  'qfei-icon-amount-outlined',
  'qfei-icon-calculation-type-outlined',
  'qfei-icon-percentage-outlined',
  'qfei-icon-attachment-outlined',
  'qfei-icon-date-range-outlined',
  'qfei-icon-multiple-selection-outlined',
  'qfei-icon-single-selection-outlined',
  'qfei-icon-reference-field-outlined',
  'qfei-icon-auto-increment-code-outlined',
  'qfei-icon-customer-outlined',
  'qfei-icon-number-outlined',
  'qfei-icon-drop-down-single-selection-outlined',
  'qfei-icon-drop-down-multiple-selection-outlined',
  'qfei-icon-sub-form-outlined',
  'qfei-icon-multi-line-text-outlined',
  'qfei-icon-single-line-text-outlined'

  // 'Baojiadan',
  // 'Bianjiye',
  // 'BookOpen',
  // 'Bumen',
  // 'Chanpin',
  // 'Chaolianjie',
  // 'Clue',
  // 'Dailishang',
  // 'Dancidaoru',
  // 'Danhangwenben',
  // 'Danxuan',
  // 'Daorujilu',
  // 'Dingdan',
  // 'Dingdan0',
  // 'Dingshirenwu',
  // 'Duohangwenben',
  // 'Duoxuan',
  // 'Fujian',
  // 'GengduoDibu',
  // 'Headset',
  // 'Hetong',
  // 'HuoshanyuyinfeiyongB27632pf',
  // 'Jilianxuanze',
  // 'Jine',
  // 'Jisuanleixing',
  // 'Kehu',
  // 'Liebiaoye',
  // 'LiuchengguanliB9jnokl3',
  // 'Maikefeng',
  // 'Pinglun',
  // 'Renyuan',
  // 'Riqi',
  // 'Setting',
  // 'Shangji',
  // 'Shenpi',
  // 'Shouhoufuwu',
  // 'Shuzi',
  // 'Tianjiaqun',
  // 'TianjiaqunQunliao',
  // 'Tianjiaxiezuoren',
  // 'Tixiaogongju',
  // 'Tixing',
  // 'VideoTwo',
  // 'Xialadanxuan',
  // 'Xialaduoxuan',
  // 'Xiangqingye',
  // 'Xinjianye',
  // 'Yinyongziduan',
  // 'Zan',
  // 'ZhanghaoquanxianBikgkki7',
  // 'Zhaozhaoguanlian',
  // 'Zidonghuaguanli',
  // 'Zujian1',
  // 'FhAdvertisingAccount',
  // 'FhAfterSalesProducts',
  // 'FhAfterSalesService',
  // 'FhAgent',
  // 'FhBank',
  // 'FhBusinessCustomers',
  // 'FhContract',
  // 'FhContractRenewal',
  // 'FhCustomerPool',
  // 'FhDailySchedule',
  // 'FhDataAnalysis',
  // 'FhDataReport',
  // 'FhFinance',
  // 'FhFund',
  // 'FhInvoice',
  // 'FhLawyer',
  // 'FhLead',
  // 'FhLeadPool',
  // 'FhMarketingCampaign',
  // 'FhMerchandise',
  // 'FhOrder',
  // 'FhOverseasCustomers',
  // 'FhPartner',
  // 'FhProcurementList',
  // 'FhProductManagement',
  // 'FhProjectManagement',
  // 'FhQuotation',
  // 'FhRetailCustomers',
  // 'FhReturnOrder',
  // 'FhSettingsCenter',
  // 'FhSubscribed',
  // 'FhTransactionRecord',
  // 'FhWonDeal',
  // 'FhWorkbench'
];
